import { render } from "./BenefitsIcon.vue?vue&type=template&id=575e0bcc"
import script from "./BenefitsIcon.vue?vue&type=script&lang=js"
export * from "./BenefitsIcon.vue?vue&type=script&lang=js"
script.render = render

export default script